import { cx } from 'flairup'

import { ClassNames } from '../../DomUtils/classNames'
import {
  commonInteractionStyles,
  stylesheet,
} from '../../Stylesheet/stylesheet'
import {
  CategoryConfig,
  categoryNameFromCategoryConfig,
} from '../../config/categoryConfig'
import { Button } from '../atoms/Button'

import { getNavigationIcon } from './helpers'

type Props = {
  isActiveCategory: boolean
  category: string
  allowNavigation: boolean
  onClick: () => void
  categoryConfig: CategoryConfig
}

export function CategoryButton({
  isActiveCategory,
  category,
  allowNavigation,
  categoryConfig,
  onClick,
}: Props) {
  return (
    <div
      className={cx(
        styles.container,
        isActiveCategory && styles.activeContainer,
      )}
      onClick={onClick}
    >
      <Button
        tabIndex={allowNavigation ? 0 : -1}
        className={cx(
          styles.catBtn,
          commonInteractionStyles.categoryBtn,
          isActiveCategory && styles.activeIcon,
          `epr-icn-${category}`,
          {
            [ClassNames.active]: isActiveCategory,
          },
        )}
        aria-label={categoryNameFromCategoryConfig(categoryConfig)}
        aria-selected={isActiveCategory}
        role="tab"
        aria-controls="epr-category-nav-id"
      >
        {getNavigationIcon(category, isActiveCategory)}
      </Button>
    </div>
  )
}

const styles = stylesheet.create({
  container: {
    borderRadius: '6px',
    padding: '3px 8px',
    display: 'flex',
    alignItems: 'center',
  },
  activeContainer: {
    background: '#F1F5F9',
  },
  activeIcon: {
    filter:
      'invert(43%) sepia(73%) saturate(2185%) hue-rotate(184deg) brightness(100%) contrast(103%)',
  },
  catBtn: {
    '.': 'epr-cat-btn',
    display: 'inline-flex',
    transition: 'opacity 0.2s ease-in-out',
    position: 'relative',
    height: 'var(--epr-category-navigation-button-size)',
    width: 'var(--epr-category-navigation-button-size)',
    backgroundSize: '20px',
    outline: 'none',
  },
})
